import {ChangeDetectionStrategy, Component, ViewEncapsulation} from "@angular/core";

@Component({
  selector: 'int-table-styling, [intTableStyling]',
  template: `<ng-content></ng-content>`,
  styleUrls: ['./int-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class IntTableStylingComponent {}
